'use client';

import { FlagExperiment } from '@/data/FlagsApi/FlagsApi.type';
import { ABTestEventType } from '@/general/helpers/CarmaTrackingApi.types';
import { pushCarmaEvent } from '@/general/helpers/carmaCritical';
import { getGroupForExperiment } from '@/general/helpers/flags/getGroupForExperiment';

/**
 * Send an AB test event
 * @param experiment - The experiment to track
 * @param type - The type of event to track
 */
export const sendABTestEvent = (experiment: FlagExperiment, type: ABTestEventType) => {
  const group = getGroupForExperiment(experiment);

  console.log('Sending A/B test event', experiment.name, type, group);

  pushCarmaEvent({
    event: 'ab_test',
    metadata: {
      experiment_name: experiment.name,
      type,
      group,
    },
  });
};
